import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Typography, Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <Container maxWidth="lg">
      <Box
        component={motion.div}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          py: 8,
        }}
      >
        <motion.div variants={itemVariants}>
          <Box
            component="img"
            src="/xicon.webp"
            alt="X Logo"
            sx={{
              width: '96px',
              height: '96px',
              mb: 4,
              objectFit: 'contain',
              display: 'block',
              margin: '0 auto'
            }}
          />
        </motion.div>

        <motion.div variants={itemVariants}>
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: { xs: '2.5rem', md: '4rem' },
              fontWeight: 'bold',
              mb: 2,
              background: 'linear-gradient(45deg, #1DA1F2, #14171A)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
            }}
          >
            X Downloader Pro
          </Typography>
        </motion.div>

        <motion.div variants={itemVariants}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.25rem', md: '1.5rem' },
              color: 'text.secondary',
              mb: 6,
              maxWidth: '800px',
            }}
          >
            Download photos and videos from X posts instantly. Despite 'Pro' being in the name, this is a 100% free service.
          </Typography>
        </motion.div>

        <motion.div
          variants={itemVariants}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/downloader')}
            startIcon={<DownloadIcon />}
            sx={{
              fontSize: '1.25rem',
              py: 2,
              px: 4,
              borderRadius: '50px',
              background: 'linear-gradient(45deg, #1DA1F2, #14171A)',
              '&:hover': {
                background: 'linear-gradient(45deg, #1A91DA, #0F1215)',
              },
            }}
          >
            Start Downloading
          </Button>
        </motion.div>

        <motion.div
          variants={itemVariants}
          style={{ marginTop: '4rem' }}
        >
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              fontStyle: 'italic',
            }}
          >
            Account-wide media extraction coming soon!
            Respect X's terms of service and use responsibly.
          </Typography>
        </motion.div>
      </Box>
    </Container>
  );
};

export default HomePage; 